var map = {
	"./Colorization1.webp": "214e",
	"./Colorization10.webp": "be29",
	"./Colorization2.webp": "1b42",
	"./Colorization3.webp": "0243",
	"./Colorization4.webp": "947d",
	"./Colorization5.webp": "1b27",
	"./Colorization6.webp": "8fe3",
	"./Colorization7.webp": "6ec9",
	"./Colorization8.webp": "bb1f",
	"./Colorization9.webp": "25cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3d10";